import React, { useState, useLayoutEffect } from "react";
import { DisplayTable} from "../components/DisplayTable/DisplayTable";
import {TopMenuBar} from "../components/TopMenuBar/TopMenuBar";
import ProgressBar from "../components/ProgressBar/ProgressBar";
import PackoutNameForm from "../components/PackoutNameForm/PackoutNameForm"
import NavBar from "../components/NavBar/NavBar";

import * as Utils from '../Utils';

import Button from '@mui/material/Button';
import "./style.css";
import "@fontsource-variable/open-sans";

export const PackingListPage = () => {
  const [isu90Counter, setIsu90Counter] = useState(0);
  const [flatPalletCounter, setFlatPalletCounter] = useState(0);
  const [cPalletCounter, setCPalletCounter]= useState(0);
  const [pallet80x120Counter,setPallet80x120Counter] = useState(0);
  const [pallet100x120Counter, setPallet100x120Counter]= useState(0);
  const [NFEVpalletCounter, setNFEVpalletCounter]= useState(0);
  const [palletTotals, setPalletTotals] = useState(0);
  
  const [rowsCounter, setRowsCounter]=useState([]);

  async function waitForSetRows(){
    const storeObject= await Utils.getAllContainersUpdateFromStore().then((result) => {
      let tempIsu90Counter = 0;
      let tempFlatPalletCounter = 0;
      let tempCPalletCounter = 0;
      let tempPallet80x120Counter = 0;
      let tempPallet100x120Counter = 0;
      let tempNFEVpalletCounter = 0;

      console.log("containers used"+JSON.stringify(result))
      result.forEach((element) => {
        if(element.containertype==="ISU-90"){
          tempIsu90Counter++;
        }   
        if(element.containertype==="463L"){
          tempFlatPalletCounter++;
        } 
        if(element.containertype==="C463L"){
          tempCPalletCounter++;
        }
        if(element.containertype==="80x120"){
          tempPallet80x120Counter++;
        }
        if(element.containertype==="100x120"){
          tempPallet100x120Counter++;
        }
        if(element.containertype==="NFEV"){
          tempNFEVpalletCounter++;
        }
      });
      setIsu90Counter(tempIsu90Counter);
      setFlatPalletCounter(tempFlatPalletCounter);
      setCPalletCounter(tempCPalletCounter);
      setPallet80x120Counter(tempPallet80x120Counter);
      setPallet100x120Counter(tempPallet100x120Counter);
      setNFEVpalletCounter(tempNFEVpalletCounter);
      let totals = tempIsu90Counter + tempFlatPalletCounter+ tempCPalletCounter+ tempPallet80x120Counter + tempPallet100x120Counter + tempNFEVpalletCounter;
      setPalletTotals(totals);
    });
    setRowsCounter(storeObject);
  }

  useLayoutEffect(() => {
    waitForSetRows();
  }, [rowsCounter])

  return (
    <div className="packingList">
      <TopMenuBar />
      <div className="under-banner">
        <ProgressBar page="pallets"></ProgressBar>
        <div className="div">
          <div className="frame-2">
            <div className="name-form">
              <div className="left-side">
                <PackoutNameForm />
                <p className="directions">
                  <span className="p-bold">
                    4. Preview placement configuration.
                  </span>{" "}
                  These recommendations are generated to optimize space usage
                  within the selected unit.
                </p>
              </div>
            </div>
            <div className="frame-3">
              <DisplayTable
                isu90Counter={isu90Counter}
                flatPalletCounter={flatPalletCounter}
                cPalletCounter={cPalletCounter}
                pallet80x120Counter={pallet80x120Counter}
                pallet100x120Counter={pallet100x120Counter}
                NFEVpalletCounter={NFEVpalletCounter}
                palletTotals={palletTotals}
              />
            </div>
          </div>
          <NavBar>
            <button className="button-8">
              <Button href="#/checklistPage" className="button-9">
                Back
              </Button>
            </button>
            <button className="button-10">
              <Button href="#/containerOverviewPage" className="button-11">
                Next Step
              </Button>
            </button>
          </NavBar>
        </div>
      </div>
    </div>
  );
};
export default PackingListPage;